import {
	updateGeneralMotorsCSISingleMetric,
	updateGeneralMotorsEBESingleMetric,
	updateGeneralMotorsSFESingleMetric,
	updateGeneralMotorsPASESingleMetric,
	updateGeneralMotorsPinnacleSingleMetric,
	updateMitsubishiCSISingleMetric,
	updateMitsubishiSSISingleMetric,
	updateVolvoCSISingleMetric,
	updateStellantisCSISingleMetric,
	updateStellantisSSISingleMetric,
} from "@DataPages/api/oem";

export async function updateProgramsValueOemHelper(oem, program, data) {
	switch (oem) {
		case "GM":
			return matchGMPrograms({ program, data });
		case "MM":
			return matchMMPrograms({ program, data });
		case "VO":
			return matchVOPrograms({ program, data });
		case "ST":
			return matchSTPrograms({ program, data });
		default:
			break;
	}

	return null;
}

const matchGMPrograms = async (args) => {
	const { program, data } = args;

	switch (program) {
		case "CSI":
			return updateGeneralMotorsCSISingleMetric(data.locationId, data.commissionCycleId, data);
		case "EBE":
			return updateGeneralMotorsEBESingleMetric(data.locationId, data.commissionCycleId, data);
		case "SFE":
			return updateGeneralMotorsSFESingleMetric(data.locationId, data.commissionCycleId, data);
		case "PASE":
			return updateGeneralMotorsPASESingleMetric(data.locationId, data.commissionCycleId, data);
		case "Pinnacle":
			return updateGeneralMotorsPinnacleSingleMetric(data.locationId, data.commissionCycleId, data);
		default:
			break;
	}

	return null;
};

const matchMMPrograms = async (args) => {
	const { program, data } = args;

	switch (program) {
		case "CSI":
			return updateMitsubishiCSISingleMetric(data.locationId, data.commissionCycleId, data);
		case "SSI":
			return updateMitsubishiSSISingleMetric(data.locationId, data.commissionCycleId, data);
		default:
			break;
	}

	return null;
};

const matchVOPrograms = async (args) => {
	const { program, data } = args;

	switch (program) {
		case "CSI":
			return updateVolvoCSISingleMetric(data.locationId, data.commissionCycleId, data);
		default:
			break;
	}

	return null;
};

const matchSTPrograms = async (args) => {
	const { program, data } = args;

	switch (program) {
		case "CSI":
			return updateStellantisCSISingleMetric(data.locationId, data.commissionCycleId, data);
		case "SSI":
			return updateStellantisSSISingleMetric(data.locationId, data.commissionCycleId, data);
		default:
			break;
	}

	return null;
};
